import { Card, CardContent, styled } from "@mui/material";

const RootStyle = styled(Card)(({ theme }) => ({
  textAlign: 'center',
  borderRadius: 5,
  [theme.breakpoints.up('md')]: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}));

export default function AdsContact() {
  return (
    <RootStyle>
      <CardContent sx={{ m: 0, p: 0, paddingBottom: "0 !important" }}>
        <a href="tel:0973328859" target="_blank" rel="noreferrer">
          <img src="/ads/qc.jpg" width={"100%"} height={"auto"} alt="" />
        </a>
      </CardContent>
    </RootStyle>
  );
}